import React, {memo, useRef} from 'react';
import cx from 'classnames';
import {noop} from '@priority-software/priority-style-react';
import {FormToolbar} from '../FormToolbar';
import {Form} from '../../../../stores/Form';
import tableStyles from '../Table/styles/Table.module.scss';
import styles from './styles.module.scss';

type Props = {
    level: number;
    componentClasses?: string;
    isHTML?: boolean;
    subFormName: string;
    runSubform: (subFormName: string, parentLevel: number, isHTMLForm?: boolean) => void;
};

const tablePlaceholderStyles = {height: 200};

export const FormSectionPlaceholder = memo((props: Props) => {
    const {level, componentClasses, isHTML, subFormName, runSubform} = props;
    const dummyForm = useRef(new Form('', {}, {Columns: []}, level));

    const startFirstSubform = () => {
        runSubform(subFormName, level - 1, isHTML);
    };

    return (
        <div className={cx(componentClasses || '')} onClick={startFirstSubform}>
            {!isHTML ? (
                <FormToolbar
                    isFormActive={false}
                    openRecordDialog={noop}
                    currentForm={dummyForm.current}
                />
            ) : null}

            {isHTML ? (
                <div className={styles.htmlPlaceholder}>
                    <div className={styles.htmlContainer} />
                </div>
            ) : (
                <div className={tableStyles.component} style={tablePlaceholderStyles} />
            )}
        </div>
    );
});
